import Vue from 'vue/dist/vue.esm'
// import Vue from 'vue'
import App from '../app.vue'
import axios from 'axios'
import VueRouter from "vue-router";

import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";

Vue.use(VueRouter);

am4core.useTheme(am4themes_animated);

document.addEventListener('DOMContentLoaded', () => {
  const app = new Vue({
    el: '#tool_box',
    data: {
    	strategy: {
    		index: '',
    		title: '',
    		intro1: '',
    		intro2: '',
    	},
    	strategies: {

    	},
    	data_time: '',
    	use_strategies: false,
    	show_strategies: false,
    	// categories: [],
    	loading: true,
    	middle: 12,
    	show_option: false,
    	add_item: false,
    	edit_item: false,
    	select_week: 'week',
    	select_call: 'call',
   		option_data: {},
   		graph_data:[{exercise_price: 10000, profit: 50}],
   		option_datum_items: {},
   		temp_item:{id: null, item_type: 'week', buy_type: "buy", call_type: "call", exercise_price: "", premium: null, amount: null, edit: false},
      custom_items: [

      ]
    },
    components: {

    },
    created() {
    	this.resetAddItem()
    	this.getOptionData()
	  },
	  computed: {

	  },
	  mounted() {
	    this.initial_graph();
	  },
	  methods: {
      initial_graph(){
        let chart = am4core.create(this.$refs.chartdiv, am4charts.XYChart);
        chart.paddingRight = 20;
        chart.data = this.graph_data;

        // Create axes
        var xAxis = chart.xAxes.push(new am4charts.ValueAxis());
        xAxis.renderer.minGridDistance = 40;
        xAxis.renderer.labels.template.rotation = 315;

        // Create value axis
        var yAxis = chart.yAxes.push(new am4charts.ValueAxis());

        // Create series
        var series1 = chart.series.push(new am4charts.LineSeries());
        series1.dataFields.valueX = "exercise_price";
        series1.dataFields.valueY = "profit";
        // series1.dataFields.valueX = "x";
        // series1.dataFields.valueY = "ay";
        series1.dataFields.value = "aValue";
        series1.strokeWidth = 2;

        var bullet1 = series1.bullets.push(new am4charts.CircleBullet());
        series1.heatRules.push({
          target: bullet1.circle,
          min: 5,
          max: 20,
          property: "radius"
        });

        bullet1.tooltipText = "指數：{valueX} , 損益：{valueY}";

        this.chart = chart;
      },
	  	GraphContainer(){
	  		if(this.show_strategies == true){
	  			return 'none'
	  		}else{
	  			return 'block'
	  		}
	  	},
	  	getAllStrategies(){
	  		let vm = this
	  		if(document.getElementById("use_strategies")){
	  			vm.use_strategies = true
	  			axios('/home/tools/id/all_strategies')
	        .then(function(response) {
	          if (response['data']['status']==true) {
	            //vm.categories = response['data']['data']['option_categories']
	            vm.strategies = response['data']['data']['option_strategies']
	            vm.loading = false
	            if(document.getElementById("strategy_id")){
	            	var sid = document.getElementById("strategy_id").value
	            	$.each(vm.strategies,function(i,e){
	            		if(e.id == sid){
	            			vm.choose_strategy(e,i)
	            		}
	            	})
	            }else{
	            	vm.show_strategies = true
	  						vm.loading = false
	            }
	          } else {
	          	vm.connectError(response['data'])
	          }
	        })
	        .catch(function(error) {
	          console.log(error)
	        });
	  		}else{
	  			vm.loading = false
	  		}
	  	},
	  	choose_strategy(s,i){
	  		var is_login = $('#zxcvbn').val()
	  		if(is_login != 'true' && i > 7){
	  			window.location.href ="/home/tools?strategies=true&strategy_id=" + s.id;
	  			return
	  		}
	  		let vm = this
	  		vm.addHashToLocation(s.id)
	  		vm.show_strategies = false
	  		vm.loading = true
	  		if(document.getElementById("use_strategies")){
	  			let path = '/home/tools/'+ s.id +'/get_strategy'
	  			axios(path)
	        .then(function(response) {
	          if (response['data']['status']==true) {
	            vm.custom_items = response['data']['data']['items']
	            $.each(vm.custom_items,function(i,e){
					if(e.item_type == 'month' && vm.option_data.month_title.includes('W')){
						e.item_type = "second_month"
					}
	            	e.premium = vm.getItemPremium(e)
	            })
	            vm.strategy = response['data']['data']['strategy']
	            vm.strategy.index = s.index
              vm.resetGraphData()
	            vm.calculateAllPremiun()
	            vm.loading = false
	          } else {
	          	vm.connectError(response['data'])
	          }
	        })
	        .catch(function(error) {
	          console.log(error)
	        });
	  		}
	  	},
	  	resetGraphData(){
	  		let vm = this
	  		let now = vm.option_data.stock_market_now
        if(this.noWeekOption()== true){
          var unit = 100
        }else{
          var unit = 50
        }
	  		
	  		let width = 12 //width*2+1 = 總指數數量，所以上下多3個，就是width+3
	  		let graph_data = []
	  		let start = 0
	  		this.middle = width
	  		if( now%unit < unit/2 ){
	  			//靠近低點
	  			start = Math.floor(now/unit)*unit - width*unit
	  		}else{
	  			//靠近高點
	  			start = Math.floor(now/unit)*unit - (width-1)*unit
	  		}
	  		for (var i = 0; i < (2*width+1); i++) {
	  			var point = {exercise_price: start+i*unit , profit : 0};
		      graph_data.push(point)
		    }
		    this.graph_data = graph_data
		    this.calculateAllPremiun()
	  	},
	  	calculateAllPremiun(){
	  		let vm = this
	  		$.each(vm.graph_data,function(index,data){
	  			vm.calculateSinglePremium(data)
	  		})
	  		vm.chart.data = vm.graph_data;
  			vm.chart.validateData();
	  	},
	  	calculateSinglePremium(data){
	  		let now = data.exercise_price
	  		let vm = this
	  		let profit = 0
	  		let lever = 0
	  		$.each(vm.custom_items,function(index,item){
	  			if(item.call_type == "call"){
	  				// 買權
	  				if(item.buy_type == "buy"){
	  					//買入買權
	  					if(now > item.exercise_price ){
	  						profit += (now-item.exercise_price-item.premium)*item.amount*50
	  					}else{
	  						profit +=  -(item.premium*item.amount)*50
	  					}
	  				}else{
	  					//賣出買權
	  					if(now > item.exercise_price){
	  						profit += (item.premium - (now - item.exercise_price))*item.amount*50

	  					}else{
	  						profit += item.premium*item.amount*50
	  					}
	  				}
	  			}else if(item.call_type == "put"){
	  				// 賣權
	  				if(item.buy_type == "buy"){
	  					//買入賣權
	  					if(now < item.exercise_price ){
	  						profit += (item.exercise_price-now-item.premium)*item.amount*50

	  					}else{
	  						profit += -item.premium*item.amount*50
	  					}
	  				}else{
	  					//賣出賣權
	  					if(now < item.exercise_price){
	  						profit += (item.premium - (item.exercise_price - now))*item.amount*50

	  					}else{
	  						profit += item.premium*item.amount*50
	  					}
	  				}
	  			}else{
	  				// 期貨
	  				if(item.item_type=="futures_big"){
	  				  lever=200
	  				}else{
	  					lever=50
	  				}

	  				if(item.buy_type == "buy"){
	  					//買入期貨
	  					profit += (now - item.exercise_price)*lever*item.amount
	  				}else{
	  					//賣出期貨
	  					profit += (item.exercise_price - now)*lever*item.amount
	  				}
	  			}
	  		})

				//計算槓桿：選擇權50、小台50、大台200

	  		data.profit = Math.round(profit)
	  	},
	  	resetAddItem(){
	  		this.temp_item = {id: null, item_type: '', buy_type: "buy", call_type: "call", exercise_price: "", premium: "", amount: null, edit: false}
	  	},
	  	getOptionData(){
	  		let vm = this
	  		axios('/home/tools/id/option_data')
        .then(function(response) {
          if (response['data']['status']==true) {
            vm.option_data = response['data']['data']['option_data']
            vm.data_time = response['data']['data']['time']
            vm.option_datum_items = response['data']['data']['option_datum_items']
            $.each(vm.custom_items,function(i,e){
            	e.premium = vm.getItemPremium(e)
            })
            vm.resetGraphData()
            vm.getAllStrategies()
          } else {
          	vm.connectError(response['data'])
          }
        })
        .catch(function(error) {
          console.log(error)
        });
	  	},
	  	refreshOptionData(){
	  		let vm = this
	  		vm.loading = true
	  		axios('/home/tools/id/option_data')
        .then(function(response) {
          if (response['data']['status']==true) {
            vm.option_data = response['data']['data']['option_data']
            vm.data_time = response['data']['data']['time']
            vm.option_datum_items = response['data']['data']['option_datum_items']
            $.each(vm.custom_items,function(i,e){
            	e.premium = vm.getItemPremium(e)
            })
            vm.calculateAllPremiun()
            vm.loading = false
          } else {
          	vm.connectError(response['data'])
          }
        })
        .catch(function(error) {
          console.log(error)
        });
	  	},
	  	getItemPremium(item){
	  		if(item.edit!=true){
	  			let vm = this
		  		let result = 0
		  		$.each(this.option_datum_items,function(index,i){
		  			if(parseInt(i.exercise_price) == parseInt(item.exercise_price) && i.item_type == item.item_type ){
		  				if(item.call_type == "call"){
			  				//如果是買權
			  				result = (i.call_deal==0)? i.call_buy : i.call_deal
			  			}else{
			  				//如果是買權
			  				result = (i.put_deal==0)? i.put_buy : i.put_deal
			  			}
		  			}
		  		})
		  		return result
	  		}else{
	  			return item.premium
	  		}
	  	},
	  	createItem(){
	  		let vm = this
	  		if(this.temp_item.amount == ""){
	  			toastr.warning('請填入口數')
	  			return
	  		}

	  		if(this.temp_item.item_type == ""){
	  			toastr.warning('請選擇部位類型')
	  			return
	  		}

	  		if(this.temp_item.exercise_price == ""){
	  			toastr.warning('請選擇或填寫履約價')
	  			return
	  		}

	  		if(this.temp_item.amount < 0 || this.temp_item.amount > 999){
	  			toastr.warning('口數須介於0~999')
	  			return
	  		}



  			vm.temp_item.id = Date.now()

  			if(vm.temp_item.premium == ''){
  				vm.temp_item.edit=false
  			}

  			if(vm.temp_item.item_type == 'futures_big' || vm.temp_item.item_type == 'futures_small'){
  				vm.temp_item.call_type = 'futures'
  			}else{
  				vm.temp_item.premium = vm.getItemPremium(vm.temp_item)
  			}
	  		this.custom_items.push(vm.temp_item)
	  		this.resetAddItem()
        this.resetGraphData()
	  		this.calculateAllPremiun()
	  		this.add_item=false

	  	},
	  	CheckProfit(p){
	  		return p < 0
	  	},
	  	getItemType(type){
			if(type=='futures_big'){
			  return "大台"
			}else if(type=="futures_small"){
			  return "小台"
			}else{
	  		  return this.option_data[`${type}_title`]
	  		}

	  	},
	  	getCallType(type){
	  	 if(type == "call"){
	  			return "CALL"
	  		}else if(type=="put"){
	  			return "PUT"
	  		}else{
	  			return "期貨"
	  		}
	  	},
	  	getBuyType(type){
	  	 return	(type == "buy")? "BUY" : "SELL"
	  	},
	  	arrayRemove(arr, value) {
	    	let index = arr.indexOf(value)
	    	if(index==0&&arr.length==1){
	    		return []
	    	}
			  return arr.filter(function(ele){
			    return ele != value;
			  });
			},
	  	deleteItem(item){
	  		let vm = this
	  		vm.custom_items = vm.arrayRemove(vm.custom_items,item)
	  		vm.calculateAllPremiun()
	  	},
	  	editItem(item){
	  		let vm = this
	  		this.temp_item = {id: item.id, item_type: item.item_type, buy_type: item.buy_type, call_type: item.call_type, exercise_price: item.exercise_price, premium: item.premium, amount: item.amount ,edit: item.edit}
	  		this.edit_item = true
	  	},
	  	saveItem(){
	  		let vm = this
	  		$.each(vm.custom_items,function(i,e){
	  			if(e.id == vm.temp_item.id){
	  				e.item_type = vm.temp_item.item_type
	  				e.buy_type = vm.temp_item.buy_type
	  				if(e.item_type == 'week' || e.item_type == 'month'|| e.item_type == 'second_month'|| e.item_type == 'fourth_data'){
	  					e.call_type = vm.temp_item.call_type
	  				}else{
	  					e.call_type = 'features'
	  				}
	  				e.exercise_price = vm.temp_item.exercise_price
	  				e.amount = vm.temp_item.amount

	  				if(vm.temp_item.edit==true && vm.temp_item.premium != ''){
		  				e.edit = true
		  				e.premium = vm.temp_item.premium
		  			}else{
		  				e.edit =false
		  			}

	  				e.premium = vm.getItemPremium(e)
	  				vm.calculateAllPremiun()
	  			}
	  		})
	  		vm.edit_item = false
	  	},
	  	canBeSelected(type){
	  		let vm = this
	  		switch (type) {
				  case 'week':
				    var result = true
			  		$.each(vm.custom_items,function(i,e){
		        	if( 
		        			(e.item_type == 'month') || 
		        			(e.item_type == 'second_month') ||
		        			(e.item_type == 'fourth_data')
		      		){
		        		result = false
		        	}
		        })

			  		if(vm.option_data.week_title.includes('W')){
			  			return (result && vm.noFuture())
			  		}else{
			  			return result
			  		}
				  case 'month':
				  	var result = true
			  		$.each(vm.custom_items,function(i,e){
		        	if( 
		        			(e.item_type == 'week') || 
		        			(e.item_type == 'second_month') ||
		        			(e.item_type == 'fourth_data')
		      		){
		        		result = false
		        	}
		        })

		        if(vm.option_data.month_title.includes('W')){
			  			return (result && vm.noFuture())
			  		}else{
			  			return result
			  		}
				  case 'second_month':
				  	var result = true
			  		$.each(vm.custom_items,function(i,e){
		        	if( 
		        			(e.item_type == 'week') || 
		        			(e.item_type == 'month') ||
		        			(e.item_type == 'fourth_data')
		      		){
		        		result = false
		        	}
		        })
			  		
			  		if(vm.option_data.second_month_title.includes('W')){
			  			return (result && vm.noFuture())
			  		}else{
			  			return result
			  		}
				  case 'fourth_data':
				  	var result = true
			  		$.each(vm.custom_items,function(i,e){
		        	if( 
		        			(e.item_type == 'week') || 
		        			(e.item_type == 'month') ||
		        			(e.item_type == 'second_month')
		      		){
		        		result = false
		        	}
		        })
			  		
			  		if(vm.option_data.fourth_data_title.includes('W')){
			  			return (result && vm.noFuture())
			  		}else{
			  			return result
			  		}
				  case 'futures_big':
				    return vm.noWeekOption()
				  case 'futures_small':
				    return vm.noWeekOption()
				  default:
				    return false
				}
	  	},
	  	noWeekOption(){
				let vm = this
	  		var result = true
	  		$.each(vm.custom_items,function(i,e){
        	if( 
        			(e.item_type == 'week' && vm.option_data.week_title.includes('W')) || 
        			(e.item_type == 'month' && vm.option_data.month_title.includes('W')) ||
        			(e.item_type == 'second_month' && vm.option_data.second_month_title.includes('W')) ||
        			(e.item_type == 'fourth_data' && vm.option_data.fourth_data_title.includes('W'))
      		){
        		result = false
        	}
        })
	  		return result
	  	},
	  	noFuture(){
				let vm=this
	  		var result = true
	  		$.each(this.custom_items,function(i,e){
        	if(e.item_type == 'futures_big' || e.item_type == 'futures_small'){
        		result = false
        	}
        })
	  		return result
	  	},
	  	addHashToLocation(id) {
	  		console.log('replace')
			  history.replaceState(
			    {},
			    null,
			    window.location.protocol + '//' + window.location.host + '/home/tools?strategies=true&strategy_id=' +  id
			  )
			},
	  	getTempPremium(){
	  		var result = 0
	  		let vm = this
	  		if(vm.temp_item.exercise_price != 0 && vm.temp_item.exercise_price != ''){
		  		$.each(vm.option_datum_items,function(index,i){
		  			if(parseInt(i.exercise_price) == parseInt(vm.temp_item.exercise_price) && i.item_type == vm.temp_item.item_type ){
		  				if(vm.temp_item.call_type == "call"){
			  				//如果是買權
			  				console.log('i',i)
			  				result = (i.call_deal==0)? i.call_buy : i.call_deal
			  			}else{
			  				//如果是賣權
			  				console.log('i',i)
			  				result = (i.put_deal==0)? i.put_buy : i.put_deal
			  			}
		  			}
		  		})
	  		}else{
	  			result = 0
	  		}
	  		vm.temp_item.premium = result
	  		return result
	  	}
	  }
  })
})
